import React from 'react'
import { statusSupplyOrderText } from '../../../helpers/status/StatusSupplyOrderHelper'

const Status = ({ status, text }) => {
  return (
    <div className={`status status-${status}`}>
        {
            text ? text : 
			statusSupplyOrderText[status] ? statusSupplyOrderText[status] : status
        }
    </div>
  )
}

export default Status